export const backToFront = (backEndData) => {
    if (!backEndData.accounts) {
        return null;
    }
    return backEndData.accounts.map(account => {
        const { referenceNumber, accountNumber, decedentRelationship, amount: _, ...rest } = account;
        const { balance, maxPayment, amountDue } = getBalanceDetails(account);
        return {
            ...rest,
            refNum: referenceNumber,
            acctNum: accountNumber,
            relationship: decedentRelationship,
            balance,
            maxPayment,
            amountDue,
            paymentEligible: !rest.accountClosed && maxPayment > 0
        };
    });
};
function getBalanceDetails({ amount, settlementAgreement, settlementOffer, monthlyPayment }) {
    const balance = amount;
    let maxPayment = balance;
    if (settlementAgreement != null) {
        maxPayment = settlementAgreement;
    }
    else if (settlementOffer != null) {
        maxPayment = settlementOffer;
    }
    if (balance < maxPayment) {
        maxPayment = balance;
    }
    let amountDue = maxPayment;
    if (monthlyPayment != null && monthlyPayment <= balance) {
        amountDue = monthlyPayment;
    }
    return {
        balance,
        maxPayment,
        amountDue
    };
}
/**
 * Uses the above constant to convert front-end data into format back-end can use
 *
 * @method frontToBackRelationship
 * @param {String} accountId Piece of FE data to build prepared data for the BE
 * @param {String} decedentRelationship Piece of FE data to build prepared data for the BE
 * @returns {Object} Converted data
 */
export const frontToBackRelationship = (accountId, decedentRelationship) => {
    if (!accountId || !decedentRelationship) {
        return null;
    }
    return {
        accountId,
        decedentRelationship
    };
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/accts/dataConversion.ts